<template>
  <div class="container">
    <DialogPrime
      :header="$t('headerCarbonForm')"
      v-model:visible="dialogChart"
      :breakpoints="{ '960px': '50vw', '640px': '50vw' }"
      :style="{ width: '40vw' }"
    >
      <div class="formgrid grid pb-7">
        <div class="field col-12 md:col-12 formgrid grid mb-0">
          <div v-for="item in yearsArray" :key="item" class="field mb-0">
            <div
              class="field border-1 align-content-center text-center pb-3 pt-3 mb-0"
              :style="{ width: '5vw' }"
              id="year"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div v-for="item in configResults" :key="item.configurationName" class="field col-12 md:col-12 mb-0">
          <div class="formgrid grid" v-tooltip.left="item.configurationName">
            <div
              v-for="result in item.resultsForConfiguration"
              :key="result.index"
              class="field border-1 align-content-center text-center pb-3 pt-3 mb-0"
              :id="colorClass(result)"
              :style="{ width: '5vw' }"
            >
              {{ result }}
            </div>
          </div>
        </div>
      </div>
      <div class="formgrid grid">
        <ButtonPrime label="Close" class="p-button actionButton" v-tooltip.top="'Close'" @click="dialogChart = false" />
      </div>
    </DialogPrime>

    <div class="formgrid grid">
      <div class="m-6" v-for="item in carbonData.configurationsForCarbon" :key="item.id" style="max-width: 100vw">
        <DataTablePrime
          title="Prime"
          :value="item.fuelInfo"
          editMode="cell"
          class="editable-cells-table field col-12"
          responsiveLayout="scroll"
          @cell-edit-complete="onCellEditComplete"
          style="text-align: center"
        >
          <template #header>
            <div class="flex justify-content-left align-items-left">
              <label class="m-0">{{ $t("configuration") }}: {{ item.configurationName }}</label>
            </div>
          </template>
          <ColumnPrime field="fuelName" :header="$t('fuelName')">
            <template #editor="{ data, field }">
              <InputTextPrime v-model="data[field]" autofocus />
            </template>
          </ColumnPrime>
          <ColumnPrime field="fuelConsumptionPerYear" :header="$t('fuelConsumptionPerYear')">
            <template #editor="{ data, field }">
              <InputTextPrime type="number" v-model="data[field]" autofocus />
            </template>
          </ColumnPrime>
           <ColumnPrime field="consumptionInTonsName" :header="$t('annualConsumptionType')" >
          <template #editor="{ data, field }">
            <DropdownPrime v-model="data[field]" :options="consumptionOptions" autofocus />
          </template>
        </ColumnPrime>
        </DataTablePrime>
      </div>
    </div>
    <div class="formgrid grid"> 
      <div class="field col-2 md:col-2 pt-4">
        <label>{{ $t("totalDistancia") }} <strong>(nm)</strong> :</label>
      </div>
      <div class="field col-2 md:col-2 pt-4">
        <InputTextPrime type="number" v-model="carbonData.distancePerYear" autofocus />
      </div>
      <div class="field col-8 md:col-2 pt-4"></div>
    </div>
    <div class="formgrid grid" id="footer">
      <div class="field col-12 md:col-9 pt-4 pb-4"></div>
      <div class="field col-12 md:col-1 pt-4 pb-4">
        <ButtonPrime label="Calc" icon="pi" @click="calc()" class="p-button actionButton" />
      </div>
      <div class="field col-12 md:col-1 pt-4 pb-4">
        <ButtonPrime label="Exit" icon="pi pi-times" @click="close()" class="p-button actionButton" />
      </div>
      <div class="field col-12 md:col-1 pt-4 pb-4">
        <ButtonPrime label="Save" icon="pi pi-save" @click="save()" class="p-button actionButton" />
      </div>
    </div>
  </div>
</template>
<script>
import CarbonService from "@/services/CarbonService";
import store from "@/store/index";
import router from "@/router/index";
import CalcCarbonIndexIndicatorService from "@/services/CalcCarbonIndexIndicatorService";
/**
 * 
import { ToastSeverity } from "primevue/api";
 */

export default {
  setup() {
    const colorClass = (data) => {
      console.log(data);

      switch (data) {
        case "A":
          return "Acolor";
        case "B":
          return "Bcolor";
        case "C":
          return "Ccolor";
        case "D":
          return "Dcolor";
        case "E":
          return "Ecolor";
        case "F":
          return "Fcolor";
      }
    };

    return { colorClass };
  },
  data() {
    return {
      currentShip: store.getters.currentShip,
      dialogChart: false,
      tableColumns: [
        {
          field: "fuelName",
          header: "Nombre del combustible",
        },
        {
          field: "fuelConsumptionPerYear",
          header: "Fuel Consumption per year",
        },
      ],
      consumptionOptions: ["MWh", "t"],
      yearsArray: [],
    };
  },
  created() {
    console.log(this.currentShip);
    this.carbonService = CarbonService.getInstance();
    this.carbonData = CarbonService.getInstance().actualizeCarbonElementForShip(this.currentShip);
    console.log("getCarbonElementForShip.- ", this.carbonData);
  },
  methods: {
    onCellEditComplete(event) {
      let { data, newValue, field } = event;
      //falta por ponerle una opcion para el campo de codigo para verificar que pone uno correcto.
      switch (field) {
        case "consumptionInTonsName":
          data[field] = newValue;
          break;
        default:
          if (newValue.length > 0) data[field] = newValue;
          else event.preventDefault();
          break;
      }
      console.log(this.carbonData);
    },
    close() {
      router.push({
        name: "home",
      });
    },
    save() {
      CarbonService.getInstance().saveCarbonData(this.currentShip, this.carbonData);
    },
    calc() {
      CalcCarbonIndexIndicatorService.getInstance().calcCarbonIndexIndicatoForShip(this.currentShip);
      this.dialogChart = true;
      this.configResults = this.currentShip.carbonData.configurationsForCarbon;
      console.log("CarbonForm", this.configResults);

      var years = this.configResults[0].resultsForConfiguration.length;
      var arrayHandler = [];

      for (var i = 0; i < years; i++) {
        arrayHandler.push(2022 + i);
      }

      this.yearsArray = arrayHandler;
      arrayHandler = [];
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  position: relative;
  flex-direction: column;
}
#footer {
  position: fixed;
  bottom: 10%;
  width: 100%;
  height: 9rem;
}
#year {
  font-weight: 700;
}
#Acolor {
  font-weight: 700;
  background-color: #66bb6a;
}
#Bcolor {
  font-weight: 700;
  background-color: #d7e3bc;
}
#Ccolor {
  font-weight: 700;
  background-color: #f6f474;
}
#Dcolor {
  font-weight: 700;
  background-color: #fbd5b5;
}
#Ecolor {
  font-weight: 700;
  background-color: #e36c09;
}
#Fcolor {
  font-weight: 700;
  background-color: #ee3e2a;
}
</style>
